module.exports = __webpack_public_path__ + "img/clock.93987c73.svg";